import { useAtomValue } from 'jotai';

import { selectedTeamIdAtom } from '~teacher/components/Account/atoms';
import { useTeams } from '~teacher/hook/team';

export function useTeamPermissionQuery(teamId: string) {
  return useTeams({
    select: (teams) => {
      const team = teams.find((t) => `${t.id}` === `${teamId}`);
      const { canOpenStripeCheckout, canOpenStripePortal, canViewPlans } =
        team?.permissions ?? {
          canViewPlans: false,
          canOpenStripeCheckout: false,
          canOpenStripePortal: false,
        };

      return {
        canOpenStripeCheckout,
        canOpenStripePortal,
        canViewPlans,
      };
    },
  });
}

export function useSelectedTeamPermissionQuery() {
  const selectedTeamId = useAtomValue(selectedTeamIdAtom);
  return useTeamPermissionQuery(selectedTeamId);
}
